import type { ITheme } from "@xterm/xterm";


//MARK: ANSI Codes
export const ANSI = {
    ORANGE: '\x1B[1;38;5;202m', //console cleared message
    TS_STRONG: '\x1B[1;37m', //bold white
    TS_WEAK: '\x1B[2;37m', //faint white
    RESET: '\x1B[0m',
} as const;


//MARK: Dark Theme
//From legacy systemLog.ejs, based on the ANSI-UP colors
const ansi16ColorsDark = {
    black: '#000000',
    brightBlack: '#555555',
    red: '#D62341',
    brightRed: '#FF5370',
    green: '#9ECE58',
    brightGreen: '#C3E88D',
    yellow: '#FAED70',
    brightYellow: '#FFCB6B',
    blue: '#396FE2',
    brightBlue: '#82AAFF',
    magenta: '#BB80B3',
    brightMagenta: '#C792EA',
    cyan: '#2DDAFD',
    brightCyan: '#89DDFF',
    white: '#D0D0D0',
    brightWhite: '#FFFFFF',
};

const baseColorsDark = {
    background: '#0e0816',
    foreground: '#f2f5f7',
    cursor: '#f42ab8',
    cursorAccent: '#08050d',
    selectionBackground: 'rgba(242, 245, 247, .22)',
    selectionForeground: '#f2f5f7',
}

export const darkThemeColors: ITheme = {
    ...baseColorsDark,
    ...ansi16ColorsDark,
};
